export default {
  name: 'Longation',
  path: '/longate-bonus',
  meta: { requiresAuth: true },
  component: () => import('@/views/longation/LongateBonus.vue'),
}
